import { TextStroke } from './TextStroke';
export default TextStroke;
